import { WebHaptics } from "web-haptics";

// Create a singleton instance
const haptics = new WebHaptics();

const hapticDirective = {
    mounted(el, binding) {
        // Get pattern from modifier or value, default to "success"
        const pattern = Object.keys(binding.modifiers)[0] || binding.value || "success";

        el._hapticHandler = () => haptics.trigger(pattern);
        el.addEventListener("click", el._hapticHandler, { capture: true });
    },
    unmounted(el) {
        if (el._hapticHandler) {
            el.removeEventListener("click", el._hapticHandler);
        }
    },
};

export default hapticDirective;
